export const dolor_catalog = [
    // {
    //     'n': 1,
    //     'tipo': 'multiple',
    //     'pregunta': '1. Indique en el diagrama las zonas donde siente dolor sombreando la parte afectada. Marque una cruz en la zona que más le duele.',
    //     'respuestas': ['Delante Derecha', 'Delante Izquierda', 'Detras Derecha', 'Detras Izquierda']
    // },
    {
        'n': 2,
        'tipo': 'metrica',
        'pregunta': '2. Por favor, evalúe su dolor rodeando con un círculo el número que mejor describa la intensidad máxima de su dolor en la última semana',
    },
    {
        'n': 3,
        'tipo': 'metrica',
        'pregunta': '3. Por favor, evalúe su dolor rodeando con un círculo el número que mejor describa la intensidad mínima de su dolor en la última semana',
    },
    {
        'n': 4,
        'tipo': 'metrica',
        'pregunta': '4. Por  favor,  evalúe  su  dolor  rodeando  con  un  círculo  el  número  que  mejor  describa  la  intensidad  mediade  su  dolor.',
    },
    {
        'n': 5,
        'tipo': 'metrica',
        'pregunta': '5. Por favor, evalúe su dolor rodeando con un círculo el número que mejor describa la intensidad de su dolor ahora mismo',
    },
    {
        'n': 6,
        'tipo': 'texto',
        'pregunta': '6. ¿Qué tipo de cosas le alivia el dolor (p. ej., caminar, estar de pie, levantar algo)?',
    },
    {
        'n': 7,
        'tipo': 'texto',
        'pregunta': '7. ¿Qué tipo de cosas empeora el dolor (p. ej., caminar, estar de pie, levantar algo)?',
    },
    {
        'n': 8,
        'tipo': 'texto',
        'pregunta': '8. ¿Qué tratamiento o medicación está recibiendo para el dolor?',
    },
    {
        'n': 9,
        'tipo': 'metrica',
        'pregunta': '9. En la última semana, ¿hasta qué punto le han aliviado los tratamientos o medicación para el dolor? Por favor, rodee con un círculo el porcentaje que corresponda al grado de alivio que ha sentido'
    },
    {
        'n': 10,
        'tipo': 'seleccion',
        'pregunta': '10. Si toma medicación, ¿cuánto tarda en volver a sentir dolor?',
        'respuestas': ['La medicación para el dolor no me ayuda nada', '1h', '2h', '3h', '4h', 'De 5 a 12h', 'Más de 12h', 'No tomo medicación para el dolor']
    },
    {
        'n': 11,
        'tipo': 'multiple',
        'pregunta': '11. Marque con una cruz la casilla que considere adecuada para cada una de las respuestas.',
        'respuestas': ['A. Los efectos del tratamiento (p. ej., medicación, operación, radiación, prótesis)', 'B. Mi enfermedad principal (la enfermedad que actualmente se está tratando y evaluando)', 'C.  Una situación no relacionada con mi enfermedad principal (p. ej., artrosis)']
    },
    {
        'n': 12,
        'tipo': 'multiple',
        'pregunta': '12. Para cada una de las siguientes palabras, marque con una cruz «sí» o «no» si ese adjetivo se aplica a su dolor.',
        'respuestas': ['Dolorido/continuo', 'Palpitante', 'Irradiante', 'Punzante', 'Fatigoso (pesado)', 'Penetrante', 'Persistente', 'Mortificante (calambre)', 'Agudo', 'Sensible', 'Quemante', 'Agotador', 'Entumecido (adormecido)', 'Penoso', 'Insoportable']
    },
    {
        'n': 13,
        'tipo': 'titulo',
        'pregunta': '13. Rodee con un círculo el número que mejor describa hasta qué punto el dolor le ha afectado en los siguientes aspectos de la vida, durante la última semana.',
    },
    {
        'n': 'A13',
        'tipo': 'metrica',
        'pregunta': '13 A. Actividades en general',
    },
    {
        'n': 'B13',
        'tipo': 'metrica',
        'pregunta': '13 B. Estado de ánimo',
    },
    {
        'n': 'C13',
        'tipo': 'metrica',
        'pregunta': '13 C. Capacidad de caminar',
    },
    {
        'n': 'D13',
        'tipo': 'metrica',
        'pregunta': '13 D. Trabajo habitual (incluye tanto el trabajo fuera de casa como las tareas domésticas)',
    },
    {
        'n': 'E13',
        'tipo': 'metrica',
        'pregunta': '13 E. Relaciones con otras personas',
    },
    {
        'n': 'F13',
        'tipo': 'metrica',
        'pregunta': '13 F. Sueño',
    },
    {
        'n': 'G13',
        'tipo': 'metrica',
        'pregunta': '13 G. Disfrutar de la vida',
    },
    {
        'n': 14,
        'tipo': 'seleccion',
        'pregunta': '14. Prefiero tomar mi medicación para el dolor:',
        'respuestas': ['De forma regular', 'Sólo cuando lo necesito', 'No tomo medicación para el dolor']
    },
    {
        'n': 15,
        'tipo': 'seleccion',
        'pregunta': '15. Tomo mi medicación para el dolor (en un período de un día)',
        'respuestas': ['No todos los días', '1 a 2 veces al día', '3 a 4 veces al día', '5 a 6 veces al día', 'Más de 6 veces al día']
    },
    {
        'n': 16,
        'tipo': 'seleccion',
        'pregunta': '16. ¿Cree que necesita una medicación más fuerte para el dolor?',
        'respuestas': ['Si', 'No', 'No lo sé']
    },
    {
        'n': 17,
        'tipo': 'seleccion',
        'pregunta': '17. ¿Cree que debería tomar más dosis de la medicación para el dolor que las que le ha recetado el médico?',
        'respuestas': ['Si', 'No', 'No lo sé']
    },
    {
        'n': 18,
        'tipo': 'seleccion',
        'pregunta': '18. ¿Está preocupado/a porque toma demasiada medicación para el dolor?',
        'respuestas': ['Si', 'No', 'No lo sé']
    },
    {
        'n': 'B18',
        'tipo': 'texto',
        'pregunta': '18 B.Si la respuesta es «sí», ¿por qué?'
    },
    {
        'n': 19,
        'tipo': 'seleccion',
        'pregunta': '19. ¿Tiene problemas con los efectos secundarios de su medicación para el dolor?',
        'respuestas': ['Si', 'No']
    },
    {
        'n': 'B19',
        'tipo': 'texto',
        'pregunta': '19 B.¿Qué efectos secundarios?'
    },
    {
        'n': 20,
        'tipo': 'seleccion',
        'pregunta': '20. ¿Cree que necesita recibir más información sobre su medicación para el dolor?',
        'respuestas': ['Si', 'No']
    },
    {
        'n': 21,
        'tipo': 'multiple',
        'pregunta': '21. Otros métodos que uso para aliviar mi dolor son (por favor, marque con una cruz todo lo que se le aplique):',
        'respuestas': ['Compresas calientes', 'Distracción', 'Compresas frías', 'Biofeedback', 'Técnicas de relajación', 'Hipnosis']
    },
    {
        'n': 'B21',
        'tipo': 'texto',
        'pregunta': '21 B.Si su respuesta es otros, por favor, especifique'
    },
    {
        'n': 22,
        'tipo': 'texto',
        'pregunta': '22. Otras medicaciones no recetadas por mi médico y que tomo para el dolor son:'
    },
]

// export const initialDolorValues = dolor_catalog.map(p => ({ p.n: p.user, liked: p.liked }));


export const initialDolorValues = dolor_catalog.filter(({ tipo }) => tipo === 'metrica').reduce(
    (obj, item) => Object.assign(obj, { [item.n]: 0 }), {}
);